import { useTransactionsExplorer } from "./hooks/useTransactionsExplorer";
import { TransactionsTable } from "./TransactionsTable";

export const TransactionsPage = () => {
  const explorer = useTransactionsExplorer();

  return (
    <div className="layout-main">
      <div className="surface-section">
        <div className="grid">
          <div className="col-12">
            <TransactionsTable {...explorer} />
          </div>
        </div>
      </div>
    </div>
  );
};
